import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { URLS } from '../../../constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
  selector: 'app-multi-speciality-consultation',
  templateUrl: './multi-speciality-consultation.component.html',
  styleUrls: ['./multi-speciality-consultation.component.css']
})
export class MultiSpecialityConsultationComponent implements OnInit {
  constructor(private utilitiesService: UtilitiesService,
              private readonly providerstateService: ProviderStateService
  ) { }
  is_uk_country: boolean = false;
  exploremore = true;
  slug: string = "";
  is_primary_provider: boolean = false;
  ngOnInit(): void {
    this.slug = this.providerstateService.getProviderSlug();
    this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
    if(URLS.IS_UK)
    {
        this.is_uk_country = true;
    }
   }
  async openLink(base_url_name: string, link: string, target: string): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }
}
